import React, {useEffect} from 'react'
import { Link } from "react-router-dom";

import NavBar from '../Common/Navbar'
import Footer from '../Common/Footer';
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '../Home/TopButton';

import blog1 from '../../assets/Images/blog1.png';
import blog2 from '../../assets/Images/blog2.png';
import blog3 from '../../assets/Images/blog3.png';
import blog4 from '../../assets/Images/blog4.png';
import blog5 from '../../assets/Images/blog5.png';
import blog6 from '../../assets/Images/blog6.png';

function Blog() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Latest Posts</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/blog">Blog</Link>
                    </div>
                </div>
            </div>
            <div className='blog'>
                <div className="container">
                    <div className="d-flex flex-wrap flex-md-row flex-sm-column flex-column gap-sm-0 gap-4 align-items-center mt-5">
                        <div className="blog-card w-100">
                            <img src={blog1} alt="blog1.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1800" */}
                        <div className="blog-card w-100">
                            <img src={blog2} alt="blog2.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1600" */}
                        <div className="blog-card w-100">
                            <img src={blog3} alt="blog3.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1800" */}
                    </div>
                    <div className="d-flex flex-wrap flex-md-row flex-sm-column flex-column gap-sm-0 gap-4 align-items-center mt-5">
                        <div className="blog-card w-100">
                            <img src={blog4} alt="blog4.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1800" */}
                        <div className="blog-card w-100">
                            <img src={blog5} alt="blog5.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1600" */}
                        <div className="blog-card w-100">
                            <img src={blog6} alt="blog6.img" />
                            <div className="card-body">
                                <h4>10 Must-Know Digital Marketing Trends In 2023</h4>
                                <a href="#">Learn More</a>
                            </div>
                        </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1800" */}
                    </div>
                </div>
            </div>
            <div className='footer'>
                <Footer />
                <FooterMenu className= 'footer-mar' />
                <Copyright />
            </div>
            <TopButton />
        </>
    )
}

export default Blog